import styled from 'styled-components';

export const StyledTabsWrapper = styled.div`
  min-height: calc(100vh - 120px);
  width: 100%;
  padding: 20px;
  background-color: ${({theme}) => theme.surface.background};
  border: 1px solid ${({theme}) => theme.surface.border};
  border-radius: 5px;
  box-shadow: 0 2px 4px ${({theme}) => theme.surface.shadow};
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 350px 1fr;
  @media screen and (max-width: 992px) {
    min-height: 100%;
    padding: 0;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    background-color: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
`;

export const StyledTabsHead = styled.div`
  padding-right: 20px;
  ${({orientation, theme}) => orientation === 'horizontal' ? 'border-right: none' : `border-right: 1px solid ${theme.tabs.border}`};
  ${({orientation, theme}) => orientation === 'horizontal' && `border-bottom: 1px solid ${theme.tabs.border}`};
  .tab-head__title {
    margin-bottom: 15px;
    padding: 15px;
    color: ${({theme}) => theme.tabs.titleColor};
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    border-bottom: 1px solid ${({theme}) => theme.tabs.border};
    @media screen and (max-width: 576px) {
      font-size: 14px;
    }
  }
  .tab-head-buttons {
    & > span {
      background-color: ${({theme}) => theme.tabs.hoverBackground};
    }
    button {
      max-width: 100%;
      padding: 12px 12px;
      font-size: 14px;
      font-family: 'Open Sans', sans-serif;
      letter-spacing: inherit;
      font-weight: 600;
      text-transform: capitalize;
      transition: all .3s ease;
      ${({orientation}) => orientation === 'horizontal' && 'border-bottom: 3px solid transparent'};
      ${({orientation}) => orientation === 'horizontal' && 'text-transform: uppercase'};
      &:hover {
        background-color: ${({theme}) => theme.tabs.hoverBackground};
      }
    }
    button.Mui-selected {
      color: ${({theme}) => theme.tabs.activeColor};
      ${({orientation, theme}) => orientation === 'horizontal' && `border-color: ${theme.tabs.indicator}`};
      ${({orientation, theme}) => orientation !== 'horizontal' && `background-color: ${theme.tabs.activeBackground}`};
      &:before {
        display: none;
      }
    }
    .MuiTabs-indicator {
      display: none;
      background-color: ${({theme}) => theme.tabs.activeColor};
    }
  }
  @media screen and (max-width: 992px) {
    ${({orientation, theme}) => orientation !== 'horizontal' && `
      padding: 20px;
      background-color: ${theme.surface.background};
      border: 1px solid ${theme.surface.border};
      border-radius: 5px;
      box-shadow: 0 2px 4px ${theme.surface.shadow};
    `};
  }
  @media screen and (max-width: 576px) {
    ${({orientation}) => orientation !== 'horizontal' &&  'padding: 15px;'};
    .tab-head-buttons button {
      padding: 12px;
      font-size: 14px;
    }
  }
`;

export const StyledHeadLinks = styled.div`
  display: grid;
  .tab-head__link_current {
    color: ${({theme}) => theme.tabs.activeColor};
    background-color: ${({theme}) => theme.tabs.activeBackground};
    opacity: 1;
    &:hover {
      color: ${({theme}) => theme.tabs.activeColor};
    }
  }
`;
export const StyledTabLink = styled.button`
  max-width: 100%;
  padding: 15px 12px;
  color: ${({theme}) => theme.text.primary};
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: inherit;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  transition: all .3s ease;
  opacity: 0.7;
  &:hover {
    color: inherit;
    background-color: ${({theme}) => theme.tabs.hoverBackground};
  }
  @media screen and (max-width: 576px) {
    padding: 14px;
    font-size: 14px;
  }
`;

export const StyledTabsBody = styled.div`
  width: 100%;
  overflow-x: auto;
  @media screen and (max-width: 992px) {
    padding: 20px;
    background-color: ${({theme}) => theme.surface.background};
    border: 1px solid ${({theme}) => theme.surface.border};
    border-radius: 5px;
    box-shadow: 0 2px 4px ${({theme}) => theme.surface.shadow};
  }
  @media screen and (max-width: 599px) {
    padding: 20px 15px;
  }
`;

export const StyledSeparator = styled.div`
  height: 1px;
  margin: 20px 0;
  background-color: ${({theme}) => theme.surface.divider};
`;
